import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Storage from './utils/storage';
import WebFont from 'webfontloader';
import ReactGA from 'react-ga4';
import Utils from './utils';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './i18n';
import './index.css';
import { testVersion } from '@/constants/common';
import '@/assets/confirm.less';
import '@/assets/animate.less';
import indexDB from '../src/utils/indexDB';
import { GoogleOAuthProvider } from '@react-oauth/google';
//ga4
ReactGA.initialize([
  { trackingId: 'G-H0XX3640GF', gaOptions: { name: 'OnlineGa4Tracker' } },
]);

// ReactGA.pageview(window.location.pathname, ['OnlineTracker', 'Tracker'])
let urlParams = new URLSearchParams(window.location.search);

WebFont.load({
  google: {
    families: ['Mulish: 200,300,400,500,600,700,800,900', 'Poppins: 400,700'],
  },
});

window.Storage = new Storage();
const rootElement = document.getElementById('hitpaw-online-root');
window.Storage.set('page-lang', rootElement.getAttribute('lang'));

//测试地址
console.log(urlParams.get('work'));
if (urlParams.has('work')) {
  rootElement.setAttribute('work', urlParams.get('work').split('?')[0]);
}
if (urlParams.has('lang')) {
  rootElement.setAttribute('lang', urlParams.get('lang'));
}

indexDB.init().then((res) => {
  ReactDOM.render(
    <GoogleOAuthProvider clientId='450956871125-16sn1fqr14u5fnh4og3pmm7h12hvhtnl.apps.googleusercontent.com'>
      <Provider store={store}>
        <App
          work={rootElement.getAttribute('work')}
          lang={rootElement.getAttribute('lang')}
        />
      </Provider>
    </GoogleOAuthProvider>,

    rootElement
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
serviceWorker.unregister();
